webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    currentDateTime: function currentDateTime() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc().add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss') + '.000Z';
    },
    refresh: function refresh() {
      this.refreshRaces();
    },
    refreshRaces: function refreshRaces() {
      var _this = this;

      var raceUrl = '';
      var loaddingmessage = '';
      var usemarketcount = 0;

      switch (this.$store.getters.screenConfig.mode) {
        case 'venue':
        case 'venuesmall':
          {
            loaddingmessage = 'Loading "Venue" Data';
            usemarketcount = this.$store.getters.screenConfig.venueMarketCount;

            break;
          }
        case 'nextthree':
          {
            loaddingmessage = 'Loading "Next Three" Data';
            usemarketcount = this.$store.getters.screenConfig.nextThreeMarketCount;

            break;
          }
        case 'four':
          {
            loaddingmessage = 'Loading "Multi-Screen" Data';
            usemarketcount = this.$store.getters.screenConfig.multiScreenMarketCount;

            break;
          }
      }

      this.$store.commit('updateIsLoading', true);
      this.$store.commit('updateScreenLoadingMessage', loaddingmessage);

      switch (this.$store.getters.screenConfig.mode) {
        case 'brand':
          {
            this.$store.commit('updateIsLoading', false);

            break;
          }
        case 'venue':
        case 'venuesmall':
        case 'nextthree':
        case 'four':
          {
            switch (this.$store.getters.screenConfig.mode) {
              case 'venuesmall':
              case 'venue':
                {
                  raceUrl = this.$store.state.betManagerApiUrl + '/rpc/refreshRaces/?dateCheck=' + this.currentDateTime() + '&bookieId=' + this.$store.state.bookieId + '&venueId=' + this.$store.getters.screenConfig.venue + '&scrreenMode=' + this.$store.getters.screenConfig.mode + '&screenName=' + this.$store.getters.screenConfig.screenName;

                  break;
                }
              case 'four':
              case 'nextthree':
                {
                  raceUrl = this.$store.state.betManagerApiUrl + '/rpc/refreshRaces/?dateCheck=' + this.currentDateTime() + '&bookieId=' + this.$store.state.bookieId + '&screenMode=' + this.$store.getters.screenConfig.mode + '&screenName=' + this.$store.getters.screenConfig.screenName;

                  break;
                }
            }

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(raceUrl, {
              headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
            }).then(function (response) {
              var screendata = response.data;
              var screendataindex = 0;

              screendata.forEach(function (bookieVenue) {
                screendataindex++;

                bookieVenue.index = screendataindex;
                bookieVenue.races = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sortBy(bookieVenue.races, function (race) {
                  return race.raceDateTime;
                });

                bookieVenue.races.forEach(function (race, index) {
                  race.index = index + 1;
                  race.markets = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sortBy(race.markets, [_this.$store.getters.screenConfig.sortBy]);

                  if (_this.$store.getters.screenConfig.sortDirection === 'DESC') {
                    race.markets = race.markets.reverse();
                  }

                  if (_this.$store.getters.screenConfig.sortBy === 'price') {
                    // If price sorting push scratched to bottom
                    var scratchedOrReservedrunners = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(race.markets, function (m) {
                      return m.scratched === true || m.price === 0;
                    });

                    scratchedOrReservedrunners.forEach(function (scratchedRunner) {
                      race.markets.push(scratchedRunner);
                    });
                  }

                  race.markets.forEach(function (market, index) {
                    market.oddsOn = market.price <= 1 && market.price !== 0;
                    market.include = index + 1 < usemarketcount;
                  });

                  race.scrollMarkets = race.markets.filter(function (market) {
                    return !market.include;
                  });
                });
              });

              _this.$store.commit('updateScreenData', screendata);
              _this.$store.commit('updateIsLoading', false);
              _this.$store.commit('updateRefreshingPrice', false);
              _this.$store.commit('updateScreenLoadingMessage', '');
            }).catch(function (error) {
              console.log(error);
            });

            break;
          }
        case 'results':
          {
            var screendata = [];

            raceUrl = this.$store.state.betManagerApiUrl + '/rpc/refreshRaces/?dateCheck=' + this.currentDateTime() + '&bookieId=' + this.$store.state.bookieId + '&screenMode=' + this.$store.getters.screenConfig.mode;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(raceUrl, {
              headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
            }).then(function (response) {
              var races = response.data;
              races.forEach(function (race, index) {
                race.index = index;

                screendata.push(race);
              });

              _this.$store.commit('updateScreenData', screendata);
              _this.$store.commit('updateIsLoading', false);
            }).catch(function (error) {
              console.log(error);
            });

            break;
          }
      }
    }
  },
  computed: {
    races: function races() {
      return this.$store.state.races;
    },
    primaryStyle: function primaryStyle() {
      return this.$store.getters.primaryStyle;
    },
    secondaryStyle: function secondaryStyle() {
      return this.$store.getters.secondaryStyle;
    }
  },
  filters: {
    satime: function satime(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(value).format('HH:mm');
    },
    race: function race(input) {
      if (input) {
        input = 'Race ' + input.substring(input.indexOf('.R'), input.length).replace('.R0', '').replace('.R', '');
      }

      return input;
    },
    venue: function venue(input) {
      if (input) {
        return input.replace('$VE ', '');
      }

      return input;
    }
  }
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(240),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f307909c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(199)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(233),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ca477e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    betManagerApiUrl: "https://demo-api.betmanager.co.za",
    socketServerUrl: "https://demo-sockets.betmanager.co.za",
    screensUrl: "https://demo-screens.betmanager.co.za",
    webUrl: "https://demo-admin.betmanager.co.za",
    infoBarMessage: 'Betmanager Screens',
    infoBarClassName: 'infobar',
    bookieId: null,
    socketId: null,
    bookieName: null,
    screenName: null,
    screenConfig: { mode: 'startup' },
    screenData: [{
      races: []
    }],
    saNow: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc().add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss') + '.000Z',
    isLoading: true,
    screenLoadingMessage: 'Preparing Screen',
    refreshingPrice: false,
    fractionTable: [],
    screens: []
  },
  getters: {
    isBookieIdSet: function isBookieIdSet(state) {
      return state.bookieId !== null;
    },
    venueDisplayName: function venueDisplayName(state) {
      if (state.venue) {
        var displayname = state.venue.ve;

        if (state.venue.ve) {
          displayname = state.venue.ve.replace('$VE ', '');
        }

        return displayname.trim().toUpperCase();
      }
    },
    screenConfig: function screenConfig(state) {
      // Setup defaults
      if (state.screenConfig) {
        if (!state.screenConfig.venueMarketCount) {
          state.screenConfig.venueMarketCount = 8;
        }

        if (!state.screenConfig.nextThreeMarketCount) {
          state.screenConfig.nextThreeMarketCount = 12;
        }

        if (!state.screenConfig.multiScreenMarketCount) {
          state.screenConfig.multiScreenMarketCount = 6;
        }

        if (!state.screenConfig.marketScrollInterval) {
          state.screenConfig.marketScrollInterval = 1;
        }

        if (!state.screenConfig.raceScrollInterval) {
          state.screenConfig.raceScrollInterval = 10;
        }

        if (!state.screenConfig.venueScrollInterval) {
          state.screenConfig.venueScrollInterval = 10;
        }
      }

      return state.screenConfig;
    },
    globalFont: function globalFont(state) {
      return {
        fontFamily: state.screenConfig.globalFont ? state.screenConfig.globalFont : '\'Roboto\', sans-serif'
      };
    },
    pageTitleBar: function pageTitleBar(state) {
      return {
        backgroundColor: state.screenConfig.pageTitleBarBackgroundColour ? state.screenConfig.pageTitleBarBackgroundColour : '#666547',
        color: state.screenConfig.pageTitleBarFontColour ? state.screenConfig.pageTitleBarFontColour : '#fff'
      };
    },
    raceTitleBar: function raceTitleBar(state) {
      return {
        backgroundColor: state.screenConfig.raceTitleBarBackgroundColour ? state.screenConfig.raceTitleBarBackgroundColour : '#fb2e01',
        color: state.screenConfig.raceTitleBarFontColour ? state.screenConfig.raceTitleBarFontColour : '#fff'
      };
    },
    marketDetails: function marketDetails(state) {
      return {
        backgroundColor: state.screenConfig.marketDetailsBackgroundColour ? state.screenConfig.marketDetailsBackgroundColour : '#ffe28a',
        color: state.screenConfig.marketDetailsFontColour ? state.screenConfig.marketDetailsFontColour : '#000'
      };
    },
    currentPrice: function currentPrice(state) {
      return {
        backgroundColor: state.screenConfig.currentPriceBackgroundColour ? state.screenConfig.currentPriceBackgroundColour : '#fff',
        color: state.screenConfig.currentPriceFontColour ? state.screenConfig.currentPriceFontColour : '#000'
      };
    },
    previousPrice: function previousPrice(state) {
      return {
        backgroundColor: state.screenConfig.previousPriceBackgroundColour ? state.screenConfig.previousPriceBackgroundColour : '#ccc',
        color: state.screenConfig.previousPriceFontColour ? state.screenConfig.previousPriceFontColour : '#000'
      };
    },
    placePrice: function placePrice(state) {
      return {
        backgroundColor: state.screenConfig.placePriceBackgroundColour ? state.screenConfig.placePriceBackgroundColour : '#e2e2e2',
        color: state.screenConfig.placePriceFontColour ? state.screenConfig.placePriceFontColour : '#000'
      };
    },
    infoBar: function infoBar(state) {
      if (state.screenConfig) {
        return {
          backgroundColor: state.screenConfig.infoBarBackgroundColour ? state.screenConfig.infoBarBackgroundColour : '#6fcb9f',
          color: state.screenConfig.infoBarFontColour ? state.screenConfig.infoBarFontColour : '#fff'
        };
      }
    },
    primaryStyle: function primaryStyle(state) {
      // Setup defaults
      if (!state.screenConfig.primaryColour) {
        state.screenConfig.primaryColour = '#42687C';
      }

      if (!state.screenConfig.primaryTextColour) {
        state.screenConfig.primaryTextColour = '#fff';
      }

      return {
        color: state.screenConfig.primaryTextColour,
        backgroundColor: state.screenConfig.primaryColour
      };
    },
    secondaryStyle: function secondaryStyle(state) {
      // Setup defaults
      if (!state.screenConfig.secondaryColour) {
        state.screenConfig.secondaryColour = '#143A4E';
      }

      if (!state.screenConfig.secondaryTextColour) {
        state.screenConfig.secondaryTextColour = '#fff';
      }

      return {
        color: state.screenConfig.secondaryTextColour,
        backgroundColor: state.screenConfig.secondaryColour
      };
    },
    marketStyle: function marketStyle(state) {
      // Setup defaults
      if (!state.screenConfig.marketColour) {
        state.screenConfig.marketColour = '#fff';
      }

      if (!state.screenConfig.marketTextColour) {
        state.screenConfig.marketTextColour = '#000';
      }

      return {
        color: state.screenConfig.marketTextColour,
        backgroundColor: state.screenConfig.marketColour
      };
    },
    currentPriceColour: function currentPriceColour(state) {
      // Setup defaults
      if (!state.screenConfig.currentPriceColour) {
        state.screenConfig.currentPriceColour = '#000';
      }

      return {
        color: state.screenConfig.currentPriceColour
      };
    },
    previousPriceColour: function previousPriceColour(state) {
      // Setup defaults
      if (!state.screenConfig.previousPriceColour) {
        state.screenConfig.previousPriceColour = '#000';
      }

      return {
        color: state.screenConfig.previousPriceColour
      };
    },
    oddsOnPriceColour: function oddsOnPriceColour(state) {
      // Setup defaults
      if (!state.screenConfig.oddsOnPriceColour) {
        state.screenConfig.oddsOnPriceColour = '#000';
      }

      return { color: state.screenConfig.oddsOnPriceColour };
    },
    marketContainerHeightVenue: function marketContainerHeightVenue(state) {
      // Setup defaults
      if (!state.screenConfig.venueRaceHeight) {
        state.screenConfig.venueRaceHeight = '';
      }

      return { height: state.screenConfig.venueRaceHeight };
    },
    marketContainerHeightNextThree: function marketContainerHeightNextThree(state) {
      // Setup defaults
      if (!state.screenConfig.nextThreeRaceHeight) {
        state.screenConfig.nextThreeRaceHeight = '';
      }

      return { height: state.screenConfig.nextThreeRaceHeight };
    },
    tickerStyle: function tickerStyle(state) {
      return {
        backgroundColor: state.screenConfig.tickerBackgroundColour ? state.screenConfig.tickerBackgroundColour : '#000',
        color: state.screenConfig.tickerFontColour ? state.screenConfig.tickerFontColour : '#fff'
      };
    },
    tickerInfo: function tickerInfo(state) {
      return {
        size: state.screenConfig.tickerSize ? state.screenConfig.tickerSize : 'medium',
        message: state.screenConfig.tickerMessage ? state.screenConfig.tickerMessage : state.bookieName,
        enabled: state.screenConfig.enableTicker ? state.screenConfig.enableTicker : false
      };
    },
    isScreenRefresh: function isScreenRefresh() {
      var name = 'isScreenRefresh';
      var url = window.location.href;

      name = name.replace(/[[\]]/g, '\\$&');

      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);

      if (!results) return null;
      if (!results[2]) return '';

      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    screens: function screens(state) {
      return state.screens;
    }
  },
  mutations: {
    changeInfoBarMessage: function changeInfoBarMessage(state, message) {
      state.infoBarMessage = message;
    },
    changeInfoBarClassName: function changeInfoBarClassName(state, className) {
      state.infoBarClassName = className;
    },
    setBookieId: function setBookieId(state, bookieId) {
      state.bookieId = bookieId;
    },
    setBookieName: function setBookieName(state, bookieName) {
      state.bookieName = bookieName;
    },
    setScreenName: function setScreenName(state, screenName) {
      state.screenName = screenName;
    },
    setSocketId: function setSocketId(state, socketId) {
      state.socketId = socketId;
    },
    resetScreen: function resetScreen(state) {
      state.bookieId = null;
      state.socketId = null;
      state.screenName = null;
    },
    changeScreenConfig: function changeScreenConfig(state, screenConfig) {
      state.screenConfig = screenConfig;
    },
    changeVenue: function changeVenue(state, venue) {
      state.venue = venue;
    },
    changeVenueTable: function changeVenueTable(state, venueTable) {
      state.venueTable = venueTable;
    },
    changeRaces: function changeRaces(state, races) {
      state.races = races;
    },
    changeRaceCount: function changeRaceCount(state, raceCount) {
      state.raceCount = raceCount;
    },
    updateSaNow: function updateSaNow(state, saNow) {
      state.saNow = saNow;
    },
    updateScreenData: function updateScreenData(state, screenData) {
      state.screenData = screenData;
    },
    updateIsLoading: function updateIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    updateScreenLoadingMessage: function updateScreenLoadingMessage(state, message) {
      state.screenLoadingMessage = message;
    },
    updateRefreshingPrice: function updateRefreshingPrice(state, refreshing) {
      state.refreshingPrice = refreshing;
    },
    updateFractionTable: function updateFractionTable(state, fractionTable) {
      state.fractionTable = fractionTable;
    },
    updateScreens: function updateScreens(state, screens) {
      state.screens = screens;
    }
  }
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(225),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */,
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Startup__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Startup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Startup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Race__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Race___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Race__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Startup',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Startup___default.a
  }, {
    path: '/race',
    name: 'Race',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Race___default.a
  }],
  props: ['infomessage']
}));

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(206)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(241),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f5d862a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _require = __webpack_require__(243),
    insertKeyFrame = _require.insertKeyFrame,
    deleteKeyFrame = _require.deleteKeyFrame,
    getWidthHeight = _require.getWidthHeight,
    getTextWidth = _require.getTextWidth;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MarqueeTips',
  props: {
    content: String,
    font: {
      type: String,
      default: '16px sans-serif'
    },
    speed: {
      type: Number,
      default: 5
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.init();
    });
  },

  methods: {
    init: function init() {
      var _this = this.$el;
      var animationName = 'marquee' + Math.random().toString(36).substring(3, 8);
      deleteKeyFrame(animationName);
      insertKeyFrame('@keyframes ' + animationName + ' {\n        0% {\n          text-indent: ' + ((_this.parentNode ? _this.parentNode.innerWidth || _this.parentNode.clientWidth : getWidthHeight().width) + 10) + 'px\n        }\n        100% {\n          text-indent: ' + -getTextWidth(this.content, this.font) + 'px\n        }\n      }');
      insertKeyFrame('@-webkit-keyframes ' + animationName + ' {\n        0% {\n          text-indent: ' + ((_this.parentNode ? _this.parentNode.innerWidth || _this.parentNode.clientWidth : getWidthHeight().width) + 10) + 'px\n        }\n        100% {\n          text-indent: ' + -getTextWidth(this.content, this.font) + 'px\n        }\n      }');
      insertKeyFrame('@-moz-keyframes ' + animationName + ' {\n        0% {\n          text-indent: ' + ((_this.parentNode ? _this.parentNode.innerWidth || _this.parentNode.clientWidth : getWidthHeight().width) + 10) + 'px\n        }\n        100% {\n          text-indent: ' + -getTextWidth(this.content, this.font) + 'px\n        }\n      }');
      insertKeyFrame('@-o-keyframes ' + animationName + ' {\n        0% {\n          text-indent: ' + ((_this.parentNode ? _this.parentNode.innerWidth || _this.parentNode.clientWidth : getWidthHeight().width) + 10) + 'px\n        }\n        100% {\n          text-indent: ' + -getTextWidth(this.content, this.font) + 'px\n        }\n      }');
      _this.style.animation = animationName + ' ' + this.speed + 's' + ' linear infinite';
      _this.style.webkitAnimation = animationName + ' ' + this.speed + 's' + ' linear infinite';
      _this.style.mozAnimation = animationName + ' ' + this.speed + 's' + ' linear infinite';
      _this.style.oAnimation = animationName + ' ' + this.speed + 's' + ' linear infinite';
    }
  },
  watch: {
    content: 'init',
    speed: 'init'
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Startup__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Startup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Startup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_InfoBar__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_InfoBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_InfoBar__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  components: {
    Startup: __WEBPACK_IMPORTED_MODULE_0__components_Startup___default.a,
    InfoBar: __WEBPACK_IMPORTED_MODULE_1__components_InfoBar___default.a
  },
  created: function created() {
    // TODO - REMOVE THIS AS IT CLEANS UP OLD LOCAL STORAGE SETTING
    localStorage.removeItem('screenName');

    var bookieid = this.getParameterByName('bookieId');

    if (bookieid) {
      localStorage.setItem('bookieId', bookieid);
    } else {
      bookieid = localStorage.getItem('bookieId');
    }
    var screenname = this.getParameterByName('screenName');

    if (screenname !== '' && screenname !== null) {
      sessionStorage.setItem('screenName', screenname);
    } else {
      screenname = sessionStorage.getItem('screenName');
    }

    this.$store.commit('setBookieId', bookieid);
    this.$store.commit('setScreenName', screenname);
  },

  methods: {
    getParameterByName: function getParameterByName(name, url) {
      if (!url) url = window.location.href;

      name = name.replace(/[[\]]/g, '\\$&');

      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);

      if (!results) return null;
      if (!results[2]) return '';

      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Ticker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Ticker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Ticker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Brand',
  components: {
    Ticker: __WEBPACK_IMPORTED_MODULE_0__components_Ticker___default.a
  },
  data: function data() {
    return {
      theTime: ''
    };
  },

  computed: {
    brandName: function brandName() {
      return this.$store.state.bookieName;
    },
    uploadedImageName: function uploadedImageName() {
      return this.$store.state.webUrl + '/uploads/' + this.$store.state.screenConfig.uploadedImageName;
    }
  },
  created: function created() {
    console.log('Brand component');
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MultiScreenSection__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MultiScreenSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_MultiScreenSection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Four',
  components: {
    MultiScreenSection: __WEBPACK_IMPORTED_MODULE_1__components_MultiScreenSection___default.a
  },
  data: function data() {
    return {
      theTime: ''
    };
  },

  computed: {
    pageTitleBar: function pageTitleBar() {
      return this.$store.getters.pageTitleBar;
    },
    uploadedImagePath: function uploadedImagePath() {
      return this.$store.state.webUrl + '/uploads/' + this.$store.state.screenConfig.uploadedImageName;
    },
    uploadedImageName: function uploadedImageName() {
      return this.$store.state.screenConfig.uploadedImageName;
    }
  },
  created: function created() {
    var _this = this;

    setInterval(function () {
      _this.theTime = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc().add(2, 'hours').format('HH:mm:ss');
      _this.$store.commit('updateSaNow', __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc().format('YYYY-MM-DDTHH:mm:ss') + '.000Z');
    }, 1000);
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfoBar',
  computed: {
    infoBarMessage: function infoBarMessage() {
      return this.$store.state.infoBarMessage;
    },
    infoBarClassName: function infoBarClassName() {
      return this.$store.state.infoBarClassName;
    },
    bookieName: function bookieName() {
      return this.$store.state.bookieName;
    },
    screenName: function screenName() {
      return this.$store.state.screenName;
    },
    infoBar: function infoBar() {
      return this.$store.getters.infoBar;
    }
  },
  methods: {
    resetScreenWindow: function resetScreenWindow() {
      sessionStorage.removeItem('screenName');

      this.$store.commit('resetScreen');

      window.location.href = '/';
    },
    resetScreenPc: function resetScreenPc() {
      localStorage.removeItem('bookieId');
      sessionStorage.removeItem('screenName');

      this.$store.commit('resetScreen');
      window.location.href = '/';
    }
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Market',
  props: ['scrollMarkets', 'placesPaid', 'placePercentage', 'venueId', 'raceId', 'marketId', 'venueIndex', 'isMulti', 'quadrant'],
  data: function data() {
    return {
      indexedMarketId: '',
      mCount: 0,
      scrollMarketIndex: 0
    };
  },

  computed: {
    marketStyle: function marketStyle() {
      return this.$store.getters.marketStyle;
    },
    silkImageUrl: function silkImageUrl() {
      if (this.market.silks) {
        return unescape(this.market.silks);
      }

      return null;
    },
    placePricePercentage: function placePricePercentage() {
      if (this.market.price) {
        return +(this.market.price * (this.placePercentage / 100)).toFixed(3);
      }

      return '0';
    },
    marketDetails: function marketDetails() {
      return this.$store.getters.marketDetails;
    },
    currentPrice: function currentPrice() {
      return this.$store.getters.currentPrice;
    },
    previousPrice: function previousPrice() {
      return this.$store.getters.previousPrice;
    },
    placePrice: function placePrice() {
      return this.$store.getters.placePrice;
    },
    market: function market() {
      var _this = this;

      var venue = null;

      if (this.isMulti) {
        var quadVenues = this.$store.state.screenData.filter(function (item) {
          return item.quadrant === _this.quadrant;
        });

        venue = quadVenues[this.venueIndex];
      } else {
        venue = this.$store.state.screenData[this.venueIndex - 1];
      }

      if (venue && 'races' in venue) {
        var race = venue.races.find(function (item) {
          return item.raceId === _this.raceId;
        });

        if (race && race.markets) {
          var market = race.markets.find(function (item) {
            return item.marketId === _this.indexedMarketId;
          });

          if (market) {
            return market;
          }
        }
      }

      return {};
    },
    displayPrice: function displayPrice() {
      var price = this.market.price;
      var fraction = this.$store.state.fractionTable.find(function (fraction) {
        return price >= fraction.priceFrom && price <= fraction.priceTo;
      });

      return fraction && this.$store.state.screenConfig.priceDisplay === 'fraction' ? fraction.numerator + '/' + fraction.denominator : price;
    },
    previousDisplayPrice: function previousDisplayPrice() {
      var _this2 = this;

      var fraction = this.$store.state.fractionTable.find(function (fraction) {
        return _this2.market.previousPrice >= fraction.priceFrom && _this2.market.previousPrice <= fraction.priceTo;
      });

      return fraction && this.$store.state.screenConfig.previousPriceDisplay === 'fraction' ? fraction.numerator + '/' + fraction.denominator : this.market.previousPrice;
    },
    placeDisplayPrice: function placeDisplayPrice() {
      var _this3 = this;

      var fraction = this.$store.state.fractionTable.find(function (fraction) {
        return _this3.placePricePercentage >= fraction.priceFrom && _this3.placePricePercentage <= fraction.priceTo;
      });

      return fraction && this.$store.state.screenConfig.placePriceDisplay === 'fraction' ? fraction.numerator + '/' + fraction.denominator : this.placePricePercentage;
    }
  },
  watch: {
    marketId: function marketId(newMarketId) {
      this.indexedMarketId = newMarketId;
    },
    raceId: function raceId() {
      this.scrollMarketIndex = 0;

      if (this.scrollMarkets && this.scrollMarkets.length) {
        this.indexedMarketId = this.scrollMarkets[this.scrollMarketIndex].marketId;
      }
    }
  },
  created: function created() {
    this.indexedMarketId = this.marketId;

    if (this.scrollMarkets && this.scrollMarkets.length) {
      this.indexedMarketId = this.scrollMarkets[0].marketId;
      this.startScrollingMarkets(0);
    }
  },

  methods: {
    startScrollingMarkets: function startScrollingMarkets() {
      var _this4 = this;

      setTimeout(function () {
        _this4.indexedMarketId = _this4.scrollMarkets[_this4.scrollMarketIndex].marketId;
        _this4.scrollMarketIndex++;

        if (_this4.scrollMarketIndex >= _this4.scrollMarkets.length) {
          _this4.scrollMarketIndex = 0;
        }

        _this4.startScrollingMarkets();
      }, this.$store.state.screenConfig.marketScrollInterval * 1000);
    }
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MarketSmall',
  props: ['scrollMarkets', 'placesPaid', 'placePercentage', 'venueId', 'raceId', 'marketId', 'venueIndex', 'isMulti', 'quadrant'],
  data: function data() {
    return {
      indexedMarketId: '',
      mCount: 0,
      scrollMarketIndex: 0
    };
  },

  computed: {
    marketStyle: function marketStyle() {
      return this.$store.getters.marketStyle;
    },
    silkImageUrl: function silkImageUrl() {
      if (this.market.silks) {
        return unescape(this.market.silks);
      }
      return null;
    },
    placePricePercentage: function placePricePercentage() {
      if (this.market.price) {
        return +(this.market.price * (this.placePercentage / 100)).toFixed(2);
      }

      return '';
    },
    marketDetails: function marketDetails() {
      return this.$store.getters.marketDetails;
    },
    currentPrice: function currentPrice() {
      return this.$store.getters.currentPrice;
    },
    previousPrice: function previousPrice() {
      return this.$store.getters.previousPrice;
    },
    placePrice: function placePrice() {
      return this.$store.getters.placePrice;
    },
    market: function market() {
      var _this = this;

      var venue = null;

      if (this.isMulti) {
        var quadvenues = this.$store.state.screenData.filter(function (item) {
          return item.quadrant === _this.quadrant;
        });

        venue = quadvenues[this.venueIndex];
      } else {
        venue = this.$store.state.screenData[this.venueIndex - 1];
      }

      if (venue) {
        var race = venue.races.find(function (item) {
          return item.raceId === _this.raceId;
        });

        if (race) {
          var market = race.markets.find(function (item) {
            return item.marketId === _this.indexedMarketId;
          });

          if (market) {
            return market;
          }
        }
      }

      return {};
    },
    displayPrice: function displayPrice() {
      var _this2 = this;

      var fraction = this.$store.state.fractionTable.find(function (fraction) {
        return _this2.market.price >= fraction.priceFrom && _this2.market.price <= fraction.priceTo;
      });

      return fraction && this.$store.state.screenConfig.priceDisplay === 'fraction' ? fraction.numerator + '/' + fraction.denominator : this.market.price;
    },
    previousDisplayPrice: function previousDisplayPrice() {
      var _this3 = this;

      var fraction = this.$store.state.fractionTable.find(function (fraction) {
        return _this3.market.previousPrice >= fraction.priceFrom && _this3.market.previousPrice <= fraction.priceTo;
      });

      return fraction && this.$store.state.screenConfig.previousPriceDisplay === 'fraction' ? fraction.numerator + '/' + fraction.denominator : this.market.previousPrice;
    },
    placeDisplayPrice: function placeDisplayPrice() {
      var _this4 = this;

      var fraction = this.$store.state.fractionTable.find(function (fraction) {
        return _this4.market.previousPrice >= fraction.priceFrom && _this4.market.previousPrice <= fraction.priceTo;
      });

      return fraction && this.$store.state.screenConfig.placePriceDisplay === 'fraction' ? fraction.numerator + '/' + fraction.denominator : this.placePricePercentage;
    }
  },
  watch: {
    marketId: function marketId(newMarketId) {
      this.indexedMarketId = newMarketId;
    },
    raceId: function raceId() {
      this.scrollMarketIndex = 0;

      if (this.scrollMarkets) {
        this.indexedMarketId = this.scrollMarkets[this.scrollMarketIndex].marketId;
      }
    }
  },
  created: function created() {
    this.indexedMarketId = this.marketId;

    if (this.scrollMarkets && this.scrollMarkets.length) {
      this.indexedMarketId = this.scrollMarkets[0].marketId;

      this.startScrollingMarkets(0);
    }
  },
  methods: {
    startScrollingMarkets: function startScrollingMarkets() {
      var _this5 = this;

      setTimeout(function () {
        _this5.indexedMarketId = _this5.scrollMarkets[_this5.scrollMarketIndex].marketId;
        _this5.scrollMarketIndex++;

        if (_this5.scrollMarketIndex >= _this5.scrollMarkets.length) {
          _this5.scrollMarketIndex = 0;
        }

        _this5.startScrollingMarkets();
      }, this.$store.state.screenConfig.marketScrollInterval * 1000);
    }
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Market__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Market___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Market__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_venuemixin__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Multiscreensection',
  components: {
    Market: __WEBPACK_IMPORTED_MODULE_0__components_Market___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_venuemixin__["a" /* default */]],
  props: ['quadrant'],
  data: function data() {
    return {
      theTime: '',
      raceIndex: 0,
      venueIndex: 0,
      timeoutStarted: false,
      raceFlash: '',
      venueFlash: '',
      nextRaceIn: 0,
      nextVenueIn: 0,
      raceTimeout: null,
      venueTimeout: null,
      mainVenueCounter: 0,
      mainRaceCounter: 0
    };
  },

  computed: {
    screenData: function screenData() {
      return this.$store.state.screenData;
    },
    raceTitleBar: function raceTitleBar() {
      return this.$store.getters.raceTitleBar;
    },
    quadVenues: function quadVenues() {
      var scope = this;

      return scope.screenData.filter(function (item) {
        return item.quadrant === scope.quadrant;
      });
    },
    quadVenue: function quadVenue() {
      var scope = this;
      var quadvenue = null;
      if (scope.quadVenues.length > 0) {
        quadvenue = scope.quadVenues[scope.venueIndex];
        if (quadvenue) {
          if (quadvenue.races.length > 0) {
            quadvenue.race = quadvenue.races[scope.raceIndex];
          }
        }
      }
      return quadvenue;
    },
    venueAndRacesReady: function venueAndRacesReady() {
      return !!(this.quadVenues && this.quadVenues.length > 0);
    },
    hasNextRace: function hasNextRace() {
      return this.quadVenue.races.length > 1;
    },
    hasNextVenue: function hasNextVenue() {
      return this.quadVenues.length > 1;
    }
  },
  watch: {
    venueAndRacesReady: function venueAndRacesReady(newReady) {
      if (newReady) {
        var scope = this;

        scope.nextRaceIn = scope.$store.state.screenConfig.raceScrollInterval;
        scope.nextVenueIn = scope.$store.state.screenConfig.venueScrollInterval;

        setInterval(function () {

          scope.mainVenueCounter++;
          scope.mainRaceCounter++;

          if (scope.nextRaceIn > 0) {
            scope.nextRaceIn--;
          }
          if (scope.nextVenueIn > 0) {
            scope.nextVenueIn--;
          }

          if (scope.mainVenueCounter >= scope.$store.state.screenConfig.venueScrollInterval) {
            scope.scrollVenue();
            scope.mainVenueCounter = 0;

            if (scope.hasNextVenue) {
              scope.mainRaceCounter = 0;
              scope.raceIndex = 0;
              scope.nextRaceIn = scope.$store.state.screenConfig.raceScrollInterval;
            }
          }

          if (scope.mainRaceCounter >= scope.$store.state.screenConfig.raceScrollInterval) {
            scope.scrollRace();
            scope.mainRaceCounter = 0;
          }
        }, 1000);
      }
    }
  },
  created: function created() {
    // moved these to watch to ensure timeout value is loaded.
    // this.startScrollingRaces();
    // this.startScrollingVenues();
  },
  methods: {
    flagImage: function flagImage(countryName) {
      if (countryName) {
        return this.$store.state.screensUrl + '/static/img/' + countryName.toLowerCase().replace(' ', '-') + '.png';
      }
    },
    venueDisplayName: function venueDisplayName(displayname) {
      if (displayname) {
        return displayname.replace('$VE ', '').trim().toUpperCase();
      }
    },
    scrollRace: function scrollRace() {
      var scope = this;
      if (scope.hasNextRace) {
        if (scope.quadVenue) {
          if (scope.raceIndex === scope.quadVenue.races.length - 1) {
            scope.raceIndex = 0;
          } else {
            scope.raceIndex++;
          }
          scope.raceFlash = 'flash';
          setTimeout(function () {
            scope.raceFlash = '';
          }, 1000);
        }

        scope.nextRaceIn = scope.$store.state.screenConfig.raceScrollInterval;
      }
    },
    scrollVenue: function scrollVenue() {
      var scope = this;
      if (scope.hasNextVenue) {
        if (scope.venueIndex === scope.quadVenues.length - 1) {
          scope.venueIndex = 0;
        } else {
          scope.venueIndex++;
        }

        scope.venueFlash = 'flash';
        setTimeout(function () {
          scope.venueFlash = '';
        }, 1000);

        scope.nextVenueIn = scope.$store.state.screenConfig.venueScrollInterval;
      }
    }
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_venuemixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Market__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Market___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Market__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Ticker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Ticker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Ticker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Nextthree',
  components: {
    Market: __WEBPACK_IMPORTED_MODULE_2__components_Market___default.a,
    Ticker: __WEBPACK_IMPORTED_MODULE_3__components_Ticker___default.a
  },
  filters: {
    race: function race(input) {
      if (input) {
        input = 'Race ' + input.substring(input.indexOf('.R'), input.length).replace('.R0', '').replace('.R', '');

        return input;
      }
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_venuemixin__["a" /* default */]],
  data: function data() {
    return {
      screenTime: ''
    };
  },

  computed: {
    venues: function venues() {
      var screenData = this.$store.state.screenData;

      if (screenData && screenData.length) {
        return screenData;
      }

      return [];
    },
    marketContainerHeightVenue: function marketContainerHeightVenue() {
      return this.$store.getters.marketContainerHeightVenue;
    },
    pageTitleBar: function pageTitleBar() {
      return this.$store.getters.pageTitleBar;
    },
    raceTitleBar: function raceTitleBar() {
      return this.$store.getters.raceTitleBar;
    },
    uploadedImagePath: function uploadedImagePath() {
      return this.$store.state.webUrl + '/uploads/' + this.$store.state.screenConfig.uploadedImageName;
    },
    uploadedImageName: function uploadedImageName() {
      return this.$store.state.screenConfig.uploadedImageName;
    },
    screenConfig: function screenConfig() {
      return this.$store.getters.screenConfig;
    }
  },
  created: function created() {
    var _this = this;

    setInterval(function () {
      _this.screenTime = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc().add(2, 'hours').format('HH:mm:ss');
    }, 1000);

    // Every 60 seconds, check if any races are in the past, or if there are no races left.
    // If either are the case, refresh the feed.
    setInterval(function () {
      if (_this.venues.length) {
        if (_this.venues[0].races.length) {
          if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(_this.venues[0].races[0].raceDateTime) < __WEBPACK_IMPORTED_MODULE_0_moment___default()(_this.currentDateTime())) {
            _this.refresh();
          } else {}
        } else {
          _this.refresh();
        }
      } else {
        _this.refresh();
      }
    }, 60000);
  },

  methods: {
    flagImage: function flagImage(countryName) {
      if (countryName) {
        return this.$store.state.screensUrl + '/static/img/' + countryName.toLowerCase().replace(' ', '-') + '.png';
      }

      return '';
    },
    venueDisplayName: function venueDisplayName(displayname) {
      if (displayname) {
        return displayname.replace('$VE ', '').trim().toUpperCase();
      }

      return '';
    },
    raceTime: function raceTime(dateTime) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(dateTime).format('HH:mm');
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Race',
  data: function data() {
    return {
      races: null
    };
  },
  created: function created() {
    this.$store.commit('changeInfoBarMessage', 'Welcome to Races page!');

    this.getVenues();
  },

  methods: {
    getVenues: function getVenues() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$store.state.screensApiUrl + '/venue', {
        headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
      }).then(function (response) {
        _this.races = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }

});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Resultmarket',
  props: ['race', 'placePercentage'],
  data: function data() {
    return {
      market: null
    };
  },

  computed: {
    marketDetails: function marketDetails() {
      return this.$store.getters.marketDetails;
    }
  },
  watch: {},
  created: function created() {},

  methods: {
    placeDisplayPrice: function placeDisplayPrice(market, placeData) {
      var price = this.market ? this.market.price : -1;
      var fraction = this.$store.state.fractionTable.find(function (fraction) {
        return price >= fraction.priceFrom && price <= fraction.priceTo;
      });

      return fraction && this.$store.state.screenConfig.placePriceDisplay === 'fraction' ? fraction.numerator + '/' + fraction.denominator : this.placePricePercentage(market, placeData);
    },
    placePricePercentage: function placePricePercentage(market, placeData) {
      if (market.startingPrice) {
        return +(market.startingPrice * (placeData.placePercentage / 100)).toFixed(2);
      }
    }
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_venuemixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ResultMarket__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ResultMarket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ResultMarket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Ticker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Ticker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Ticker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Venue',
  components: {
    ResultMarket: __WEBPACK_IMPORTED_MODULE_2__components_ResultMarket___default.a,
    Ticker: __WEBPACK_IMPORTED_MODULE_3__components_Ticker___default.a
  },
  filters: {
    race: function race(input) {
      if (input !== null && input !== undefined) {
        input = 'Race ' + input.substring(input.indexOf('.R'), input.length).replace('.R0', '').replace('.R', '');
      }
      return input;
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_venuemixin__["a" /* default */]],
  data: function data() {
    return {
      theTime: ''
    };
  },

  computed: {
    screenData: function screenData() {
      return this.$store.state.screenData;
    },
    venueDate: function venueDate() {
      if (this.screenData[0].venueDate !== undefined) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.screenData[0].venueDate).add(2, 'hours').format('YYYY-MM-DD');
      }

      return '';
    },
    marketContainerHeightVenue: function marketContainerHeightVenue() {
      return this.$store.getters.marketContainerHeightVenue;
    },
    pageTitleBar: function pageTitleBar() {
      return this.$store.getters.pageTitleBar;
    },
    raceTitleBar: function raceTitleBar() {
      return this.$store.getters.raceTitleBar;
    },
    uploadedImagePath: function uploadedImagePath() {
      return this.$store.state.webUrl + '/uploads/' + this.$store.state.screenConfig.uploadedImageName;
    },
    uploadedImageName: function uploadedImageName() {
      return this.$store.state.screenConfig.uploadedImageName;
    }
  },
  created: function created() {
    var _this = this;

    setInterval(function () {
      _this.theTime = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc().add(2, 'hours').format('HH:mm:ss');
      _this.$store.commit('updateSaNow', __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc().format('YYYY-MM-DDTHH:mm:ss') + '.000Z');
    }, 1000);

    setInterval(function () {
      _this.refresh();
    }, 60000);
  },
  methods: {
    flagImage: function flagImage(countryName) {
      if (countryName) {
        return this.$store.state.screensUrl + '/static/img/' + countryName.toLowerCase().replace(' ', '-') + '.png';
      }

      return '';
    },
    venueDisplayName: function venueDisplayName(displayname) {
      if (displayname) {
        return displayname.replace('$VE ', '').trim().toUpperCase();
      }

      return '';
    }
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  data: function data() {
    return {
      bookieId: '',
      screenName: '',
      hasBookieId: false
    };
  },

  computed: {
    screens: function screens() {
      return this.$store.getters.screens;
    }
  },
  created: function created() {
    if (localStorage.getItem('bookieId')) {
      this.hasBookieId = true;

      this.getScreens();
    }
  },

  methods: {
    saveBookie: function saveBookie() {
      localStorage.setItem('bookieId', this.bookieId);

      this.hasBookieId = true;

      this.getScreens();
    },
    saveScreen: function saveScreen(screenName) {
      this.screenName = screenName;

      sessionStorage.setItem('screenName', screenName);

      window.location.href = '/#/?bookieId=' + this.bookieId + '&screenName=' + this.screenName;

      window.location.reload();
    },
    getScreens: function getScreens() {
      var _this = this;

      var url = this.$store.state.betManagerApiUrl + '/screen/?populate=&where={"bookie":"' + localStorage.getItem('bookieId') + '"}';

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, {
        headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
      }).then(function (response) {
        _this.$store.commit('updateScreens', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Settings__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Venue__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Venue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Venue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VenueSmall__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VenueSmall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VenueSmall__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NextThree__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NextThree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NextThree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Results__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Results___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Results__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Brand__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Brand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Brand__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Four__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Four___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Four__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_socket_io__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_socket_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_socket_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_venuemixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















__WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_socket_io___default.a, __WEBPACK_IMPORTED_MODULE_10__store__["a" /* store */].state.socketServerUrl);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Startup',
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_0__components_Settings___default.a,
    Venue: __WEBPACK_IMPORTED_MODULE_1__components_Venue___default.a,
    VenueSmall: __WEBPACK_IMPORTED_MODULE_2__components_VenueSmall___default.a,
    NextThree: __WEBPACK_IMPORTED_MODULE_3__components_NextThree___default.a,
    Results: __WEBPACK_IMPORTED_MODULE_4__components_Results___default.a,
    Brand: __WEBPACK_IMPORTED_MODULE_5__components_Brand___default.a,
    Four: __WEBPACK_IMPORTED_MODULE_6__components_Four___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_venuemixin__["a" /* default */]],
  data: function data() {
    return {
      socketConnected: false,
      showRetry: false
    };
  },

  computed: {
    isBookieIdSet: function isBookieIdSet() {
      return this.$store.getters.isBookieIdSet;
    },
    screenConfig: function screenConfig() {
      return this.$store.getters.screenConfig;
    },
    isScreenRefresh: function isScreenRefresh() {
      return this.$store.getters.isScreenRefresh;
    },
    isScreenNameSet: function isScreenNameSet() {
      return sessionStorage.getItem('screenName') !== null;
    }
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      if (!_this.socketConnected) {
        _this.$store.commit('changeInfoBarMessage', 'Unable to connect to Socket Server');
        _this.$store.commit('changeInfoBarClassName', 'infobar infobar-error');
        _this.showRetry = true;
      }
    }, 4000);
  },

  methods: {
    retry: function retry() {
      localStorage.removeItem('bookieId');
      sessionStorage.removeItem('screenName');
      this.$store.commit('resetScreen');
      window.location.href = '/#/';
      window.location.reload();
    }
  },
  method: {
    resetScreen: function resetScreen() {
      localStorage.removeItem('bookieId');
      sessionStorage.removeItem('screenName');

      this.$store.commit('resetScreen');

      window.location.href = '/';
    }
  },
  sockets: {
    connect: function connect() {
      var _this2 = this;

      this.socketConnected = true;
      this.showRetry = false;
      this.$store.commit('changeInfoBarMessage', 'Socket Connected');
      this.$store.commit('changeInfoBarClassName', 'infobar');

      // Set delay to ensure bookieid has been loaded correctly first
      setTimeout(function () {
        _this2.$store.commit('changeInfoBarClassName', 'infobar');

        if (_this2.$store.state.bookieId !== null && _this2.isScreenNameSet) {
          _this2.$socket.emit('messageFromClient', {
            messageType: 'link',
            data: {
              bookieId: _this2.$store.state.bookieId,
              socketId: _this2.$socket.id,
              identity: _this2.$store.state.screenName,
              connectionType: 'screen'
            }
          });

          _this2.$store.commit('setSocketId', _this2.$socket.id);

          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(_this2.$store.state.betManagerApiUrl + '/bookie/' + _this2.$store.state.bookieId + '/?populate=', {
            headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
          }).then(function (response) {
            _this2.$store.commit('setBookieName', response.data.companyName);

            _this2.$store.commit('changeInfoBarMessage', 'Screen is connected to server using socket id: ' + _this2.$socket.id + ' and bookie id: ' + _this2.$store.state.bookieId);

            // lets now preload all fraction table data
            var fractionurl = _this2.$store.state.betManagerApiUrl + '/fractiontable/?populate=';

            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(fractionurl, {
              headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
            }).then(function (response) {
              var fractiontable = response.data;

              _this2.$store.commit('updateFractionTable', fractiontable);
            }).catch(function (error) {
              console.log(error);
            });

            // now that we are all setup, lets check if there is a preset config for this connection
            var url = _this2.$store.state.betManagerApiUrl + '/screen/?populate=&where={"bookie": "' + _this2.$store.state.bookieId + '","screenName":"' + _this2.$store.state.screenName + '"}';

            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(url, {
              headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
            }).then(function (response) {
              if (!response.data.length) {
                _this2.$store.commit('changeInfoBarMessage', 'It looks like this Screen Configuration does not exist. Please reset.');
              }

              _this2.$store.commit('changeScreenConfig', response.data[0]);

              document.body.style.fontFamily = _this2.$store.getters.globalFont.fontFamily;

              _this2.refresh();
            });
          }).catch(function (error) {
            if (error.response) {
              if (error.response.status === 404) {
                _this2.$store.commit('changeInfoBarMessage', 'No Bookie found with and ID of : ' + _this2.$store.state.bookieId);
                _this2.$store.commit('changeInfoBarClassName', 'infobar infobar-error');
              }
            } else {
              _this2.$store.commit('changeInfoBarMessage', 'Network Error connecting to API');
              _this2.$store.commit('changeInfoBarClassName', 'infobar infobar-error');
            }
          });
        } else {
          if (!_this2.$store.state.bookieId) {
            _this2.$store.commit('changeInfoBarMessage', 'Connected to server but no Bookie ID present');
          }
          if (!_this2.isScreenNameSet) {
            _this2.$store.commit('changeInfoBarMessage', 'Connected to server but no Screen Name set');
          }

          _this2.$store.commit('updateIsLoading', false);
          _this2.$store.commit('updateScreenLoadingMessage', '');
        }
      }, 2000);
    },
    messageToBookie: function messageToBookie(msg) {
      switch (msg.messageType) {
        case 'config-change':
          {
            window.location.href = '/#/';
            window.location.reload();

            break;
          }
        case 'price-change':
          {
            this.$store.commit('updateRefreshingPrice', true);

            // If there was a price change and we are a venue, then refresh the whole screen
            if (this.$store.state.screenConfig.mode === 'venue' && msg.data.venueId === this.$store.state.screenData[0].venueId) {
              this.$store.commit('changeInfoBarMessage', 'Last price update received at ' + __WEBPACK_IMPORTED_MODULE_12_moment___default.a.utc().format('HH:mm:ss'));
              this.refresh();
            }

            // If there was a price change and we are next three or four, then *placeholder text*
            if (this.$store.state.screenConfig.mode === 'nextthree' || this.$store.state.screenConfig.mode === 'four') {
              var hasRaceInNextThree = false;

              this.$store.state.screenData.forEach(function (bookieVenue) {
                bookieVenue.races.forEach(function (bookieRace) {

                  if (bookieRace.raceId === msg.data.raceId) {
                    hasRaceInNextThree = true;
                  }
                });
              });

              if (hasRaceInNextThree) {
                this.$store.commit('changeInfoBarMessage', 'Last price update received at ' + __WEBPACK_IMPORTED_MODULE_12_moment___default.a.utc().format('HH:mm:ss'));
                this.refresh();
              }
            }
          }
      }
    }
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_marquee_tips__ = __webpack_require__(242);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Ticker',
  components: {
    MarqueeTips: __WEBPACK_IMPORTED_MODULE_0_vue_marquee_tips__["a" /* default */]
  },
  computed: {
    tickerStyle: function tickerStyle() {
      return this.$store.getters.tickerStyle;
    },
    tickerInfo: function tickerInfo() {
      return this.$store.getters.tickerInfo;
    },
    tickerSizeClass: function tickerSizeClass() {
      return 'marquee-' + this.tickerInfo.size;
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_venuemixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Market__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Market___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Market__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Ticker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Ticker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Ticker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Venue',
  components: {
    Market: __WEBPACK_IMPORTED_MODULE_2__components_Market___default.a,
    Ticker: __WEBPACK_IMPORTED_MODULE_3__components_Ticker___default.a
  },
  // filters: {
  //   race: function(input) {
  //     if (input !== null && input !== undefined) {
  //       input = 'Race ' + input.substring(input.indexOf('.R'), input.length).replace('.R0', '').replace('.R', '');
  //     }
  //     return input;
  //   }
  // },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_venuemixin__["a" /* default */]],
  data: function data() {
    return {
      theTime: ''
    };
  },

  computed: {
    venueDisplayName: function venueDisplayName() {
      if (this.screenData[0].ve !== undefined) {
        var displayname = this.screenData.ve;

        if (this.screenData[0].ve) {
          displayname = this.screenData[0].ve.replace('$VE ', '');
        }

        return displayname.trim().toUpperCase();
      }

      return '';
    },
    screenData: function screenData() {
      return this.$store.state.screenData;
    },
    venueDate: function venueDate() {
      if (this.screenData[0].venueDate !== undefined) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.screenData[0].venueDate).add(2, 'hours').format('YYYY-MM-DD');
      }

      return '';
    },
    marketContainerHeightVenue: function marketContainerHeightVenue() {
      return this.$store.getters.marketContainerHeightVenue;
    },
    countryFlag: function countryFlag() {
      if (this.screenData[0].countryName !== undefined) {
        return this.$store.state.screensUrl + '/static/img/' + this.screenData[0].countryName.toLowerCase().replace(' ', '-') + '.png';
      }

      return '';
    },
    pageTitleBar: function pageTitleBar() {
      return this.$store.getters.pageTitleBar;
    },
    raceTitleBar: function raceTitleBar() {
      return this.$store.getters.raceTitleBar;
    },
    uploadedImagePath: function uploadedImagePath() {
      return this.$store.state.webUrl + '/uploads/' + this.$store.state.screenConfig.uploadedImageName;
    },
    uploadedImageName: function uploadedImageName() {
      return this.$store.state.screenConfig.uploadedImageName;
    }
  },
  created: function created() {
    var _this = this;

    setInterval(function () {
      _this.theTime = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc().add(2, 'hours').format('HH:mm:ss');
      _this.$store.commit('updateSaNow', __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc().format('YYYY-MM-DDTHH:mm:ss') + '.000Z');
    }, 1000);

    setInterval(function () {
      if (_this.$store.state.screenData[0].races.length && _this.$store.state.screenData[0].races[0] && __WEBPACK_IMPORTED_MODULE_0_moment___default()(_this.$store.state.screenData[0].races[0].raceDateTime).add(2, 'hours') < __WEBPACK_IMPORTED_MODULE_0_moment___default()(_this.$store.state.saNow)) {
        _this.refresh();
      }
    }, 10000);
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_venuemixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MarketSmall__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MarketSmall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MarketSmall__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Ticker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Ticker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Ticker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VenueSmall',
  components: {
    MarketSmall: __WEBPACK_IMPORTED_MODULE_2__components_MarketSmall___default.a,
    Ticker: __WEBPACK_IMPORTED_MODULE_3__components_Ticker___default.a
  },
  filters: {
    race: function race(input) {
      if (input) {
        input = 'Race ' + input.substring(input.indexOf('.R'), input.length).replace('.R0', '').replace('.R', '');
      }

      return input;
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_venuemixin__["a" /* default */]],
  data: function data() {
    return {
      theTime: ''
    };
  },

  computed: {
    venueDisplayName: function venueDisplayName() {
      if (this.screenData[0].ve !== undefined) {
        var displayname = this.screenData.ve;

        if (this.screenData[0].ve) {
          displayname = this.screenData[0].ve.replace('$VE ', '');
        }

        return displayname.trim().toUpperCase();
      }

      return '';
    },
    screenData: function screenData() {
      return this.$store.state.screenData;
    },
    venueDate: function venueDate() {
      if (this.screenData[0].venueDate !== undefined) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.screenData[0].venueDate).format('YYYY-MM-DD');
      }

      return '';
    },
    marketContainerHeightVenue: function marketContainerHeightVenue() {
      return this.$store.getters.marketContainerHeightVenue;
    },
    countryFlag: function countryFlag() {
      if (this.screenData[0].countryName !== undefined) {
        return this.$store.state.screensUrl + '/static/img/' + this.screenData[0].countryName.toLowerCase().replace(' ', '-') + '.png';
      }

      return '';
    },
    pageTitleBar: function pageTitleBar() {
      return this.$store.getters.pageTitleBar;
    },
    raceTitleBar: function raceTitleBar() {
      return this.$store.getters.raceTitleBar;
    },
    uploadedImagePath: function uploadedImagePath() {
      return this.$store.state.webUrl + '/uploads/' + this.$store.state.screenConfig.uploadedImageName;
    },
    uploadedImageName: function uploadedImageName() {
      return this.$store.state.screenConfig.uploadedImageName;
    }
  },
  created: function created() {
    var _this = this;

    setInterval(function () {
      _this.theTime = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc().add(2, 'hours').format('HH:mm:ss');
      _this.$store.commit('updateSaNow', __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc().format('YYYY-MM-DDTHH:mm:ss') + '.000Z');
    }, 1000);

    setInterval(function () {
      if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(_this.$store.state.screenData[0].races[0].raceDateTime).add(2, 'hours') < __WEBPACK_IMPORTED_MODULE_0_moment___default()(_this.$store.state.saNow)) {
        _this.refresh();
      }
    }, 10000);
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(10);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  template: '<App/>'
});

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 16,
	"./af.js": 16,
	"./ar": 23,
	"./ar-dz": 17,
	"./ar-dz.js": 17,
	"./ar-kw": 18,
	"./ar-kw.js": 18,
	"./ar-ly": 19,
	"./ar-ly.js": 19,
	"./ar-ma": 20,
	"./ar-ma.js": 20,
	"./ar-sa": 21,
	"./ar-sa.js": 21,
	"./ar-tn": 22,
	"./ar-tn.js": 22,
	"./ar.js": 23,
	"./az": 24,
	"./az.js": 24,
	"./be": 25,
	"./be.js": 25,
	"./bg": 26,
	"./bg.js": 26,
	"./bm": 27,
	"./bm.js": 27,
	"./bn": 29,
	"./bn-bd": 28,
	"./bn-bd.js": 28,
	"./bn.js": 29,
	"./bo": 30,
	"./bo.js": 30,
	"./br": 31,
	"./br.js": 31,
	"./bs": 32,
	"./bs.js": 32,
	"./ca": 33,
	"./ca.js": 33,
	"./cs": 34,
	"./cs.js": 34,
	"./cv": 35,
	"./cv.js": 35,
	"./cy": 36,
	"./cy.js": 36,
	"./da": 37,
	"./da.js": 37,
	"./de": 40,
	"./de-at": 38,
	"./de-at.js": 38,
	"./de-ch": 39,
	"./de-ch.js": 39,
	"./de.js": 40,
	"./dv": 41,
	"./dv.js": 41,
	"./el": 42,
	"./el.js": 42,
	"./en-au": 43,
	"./en-au.js": 43,
	"./en-ca": 44,
	"./en-ca.js": 44,
	"./en-gb": 45,
	"./en-gb.js": 45,
	"./en-ie": 46,
	"./en-ie.js": 46,
	"./en-il": 47,
	"./en-il.js": 47,
	"./en-in": 48,
	"./en-in.js": 48,
	"./en-nz": 49,
	"./en-nz.js": 49,
	"./en-sg": 50,
	"./en-sg.js": 50,
	"./eo": 51,
	"./eo.js": 51,
	"./es": 55,
	"./es-do": 52,
	"./es-do.js": 52,
	"./es-mx": 53,
	"./es-mx.js": 53,
	"./es-us": 54,
	"./es-us.js": 54,
	"./es.js": 55,
	"./et": 56,
	"./et.js": 56,
	"./eu": 57,
	"./eu.js": 57,
	"./fa": 58,
	"./fa.js": 58,
	"./fi": 59,
	"./fi.js": 59,
	"./fil": 60,
	"./fil.js": 60,
	"./fo": 61,
	"./fo.js": 61,
	"./fr": 64,
	"./fr-ca": 62,
	"./fr-ca.js": 62,
	"./fr-ch": 63,
	"./fr-ch.js": 63,
	"./fr.js": 64,
	"./fy": 65,
	"./fy.js": 65,
	"./ga": 66,
	"./ga.js": 66,
	"./gd": 67,
	"./gd.js": 67,
	"./gl": 68,
	"./gl.js": 68,
	"./gom-deva": 69,
	"./gom-deva.js": 69,
	"./gom-latn": 70,
	"./gom-latn.js": 70,
	"./gu": 71,
	"./gu.js": 71,
	"./he": 72,
	"./he.js": 72,
	"./hi": 73,
	"./hi.js": 73,
	"./hr": 74,
	"./hr.js": 74,
	"./hu": 75,
	"./hu.js": 75,
	"./hy-am": 76,
	"./hy-am.js": 76,
	"./id": 77,
	"./id.js": 77,
	"./is": 78,
	"./is.js": 78,
	"./it": 80,
	"./it-ch": 79,
	"./it-ch.js": 79,
	"./it.js": 80,
	"./ja": 81,
	"./ja.js": 81,
	"./jv": 82,
	"./jv.js": 82,
	"./ka": 83,
	"./ka.js": 83,
	"./kk": 84,
	"./kk.js": 84,
	"./km": 85,
	"./km.js": 85,
	"./kn": 86,
	"./kn.js": 86,
	"./ko": 87,
	"./ko.js": 87,
	"./ku": 88,
	"./ku.js": 88,
	"./ky": 89,
	"./ky.js": 89,
	"./lb": 90,
	"./lb.js": 90,
	"./lo": 91,
	"./lo.js": 91,
	"./lt": 92,
	"./lt.js": 92,
	"./lv": 93,
	"./lv.js": 93,
	"./me": 94,
	"./me.js": 94,
	"./mi": 95,
	"./mi.js": 95,
	"./mk": 96,
	"./mk.js": 96,
	"./ml": 97,
	"./ml.js": 97,
	"./mn": 98,
	"./mn.js": 98,
	"./mr": 99,
	"./mr.js": 99,
	"./ms": 101,
	"./ms-my": 100,
	"./ms-my.js": 100,
	"./ms.js": 101,
	"./mt": 102,
	"./mt.js": 102,
	"./my": 103,
	"./my.js": 103,
	"./nb": 104,
	"./nb.js": 104,
	"./ne": 105,
	"./ne.js": 105,
	"./nl": 107,
	"./nl-be": 106,
	"./nl-be.js": 106,
	"./nl.js": 107,
	"./nn": 108,
	"./nn.js": 108,
	"./oc-lnc": 109,
	"./oc-lnc.js": 109,
	"./pa-in": 110,
	"./pa-in.js": 110,
	"./pl": 111,
	"./pl.js": 111,
	"./pt": 113,
	"./pt-br": 112,
	"./pt-br.js": 112,
	"./pt.js": 113,
	"./ro": 114,
	"./ro.js": 114,
	"./ru": 115,
	"./ru.js": 115,
	"./sd": 116,
	"./sd.js": 116,
	"./se": 117,
	"./se.js": 117,
	"./si": 118,
	"./si.js": 118,
	"./sk": 119,
	"./sk.js": 119,
	"./sl": 120,
	"./sl.js": 120,
	"./sq": 121,
	"./sq.js": 121,
	"./sr": 123,
	"./sr-cyrl": 122,
	"./sr-cyrl.js": 122,
	"./sr.js": 123,
	"./ss": 124,
	"./ss.js": 124,
	"./sv": 125,
	"./sv.js": 125,
	"./sw": 126,
	"./sw.js": 126,
	"./ta": 127,
	"./ta.js": 127,
	"./te": 128,
	"./te.js": 128,
	"./tet": 129,
	"./tet.js": 129,
	"./tg": 130,
	"./tg.js": 130,
	"./th": 131,
	"./th.js": 131,
	"./tk": 132,
	"./tk.js": 132,
	"./tl-ph": 133,
	"./tl-ph.js": 133,
	"./tlh": 134,
	"./tlh.js": 134,
	"./tr": 135,
	"./tr.js": 135,
	"./tzl": 136,
	"./tzl.js": 136,
	"./tzm": 138,
	"./tzm-latn": 137,
	"./tzm-latn.js": 137,
	"./tzm.js": 138,
	"./ug-cn": 139,
	"./ug-cn.js": 139,
	"./uk": 140,
	"./uk.js": 140,
	"./ur": 141,
	"./ur.js": 141,
	"./uz": 143,
	"./uz-latn": 142,
	"./uz-latn.js": 142,
	"./uz.js": 143,
	"./vi": 144,
	"./vi.js": 144,
	"./x-pseudo": 145,
	"./x-pseudo.js": 145,
	"./yo": 146,
	"./yo.js": 146,
	"./zh-cn": 147,
	"./zh-cn.js": 147,
	"./zh-hk": 148,
	"./zh-hk.js": 148,
	"./zh-mo": 149,
	"./zh-mo.js": 149,
	"./zh-tw": 150,
	"./zh-tw.js": 150
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(236),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(194)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(228),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(229),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(239),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(198)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(232),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46963633",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(197)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(231),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42bcddc8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(200)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(237),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(203)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(238),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f92603e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(227),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a8f367e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(226),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(230),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e847c77",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(235),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ef11580",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "startup-container"
  }, [(_vm.screenConfig) ? _c('div', {
    staticClass: "screen-config-container"
  }, [((!_vm.isBookieIdSet || !_vm.isScreenNameSet) && _vm.screenConfig.mode === 'startup') ? _c('Settings') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'venue') ? _c('Venue') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'venuesmall') ? _c('VenueSmall') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'nextthree') ? _c('NextThree') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'results') ? _c('Results') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'brand') ? _c('Brand') : _vm._e(), _vm._v(" "), (_vm.screenConfig.mode === 'four') ? _c('Four') : _vm._e(), _vm._v(" "), (_vm.$store.state.isLoading && !_vm.$store.state.refreshingPrice) ? _c('div', {
    staticClass: "screen-loading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader--text"
  }, [_vm._v("\n            " + _vm._s(_vm.$store.state.screenLoadingMessage) + "\n          ")])])])]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-4 col-md-4 col-md-offset-4"
  }, [(!_vm.hasBookieId) ? _c('div', [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveBookie()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bookieId"
    }
  }, [_vm._v("Bookie ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookieId),
      expression: "bookieId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.bookieId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookieId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Save\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.hasBookieId) ? _c('div', {
    staticClass: "text-center"
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n          Choose Screen\n        ")]), _vm._v(" "), _vm._l((_vm.screens), function(screen) {
    return _c('div', {
      key: screen.id,
      staticStyle: {
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "screen-button text-center"
    }, [_c('button', {
      staticClass: "btn btn-success btn-lg",
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.saveScreen(screen.screenName)
        }
      }
    }, [_vm._v("\n              " + _vm._s(screen.screenName) + "\n            ")])])])
  })], 2) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n              Setup Bookie\n            ")])])
}]}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "venue-title-bar",
    style: (_vm.pageTitleBar)
  }, [_c('div', {
    staticClass: "venue-title"
  }, [_vm._v("\n      RESULTS\n    ")]), _vm._v(" "), (_vm.uploadedImageName) ? _c('div', {
    staticClass: "venue-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.uploadedImagePath,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "the-time"
  }, [_vm._v("\n      " + _vm._s(_vm.theTime) + "\n    ")])]), _vm._v(" "), _c('Ticker'), _vm._v(" "), _c('div', {
    staticClass: "flex-race-container"
  }, _vm._l((_vm.screenData), function(race) {
    return _c('div', {
      key: race.index,
      staticClass: "flex-race-item",
      class: {
        noedge: race.index % 3 === 0
      }
    }, [_c('div', {
      staticClass: "race-title-bar",
      style: (_vm.raceTitleBar)
    }, [_c('div', {
      staticClass: "race-venue-flag"
    }), _vm._v(" "), _c('div', {
      staticClass: "race-venue-name"
    }, [_c('div', {
      staticClass: "venue-name"
    }, [_vm._v("\n            " + _vm._s(_vm.venueDisplayName(race.ve)) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "race-name"
    }, [_vm._v("\n            " + _vm._s(_vm._f("race")(race.fn)) + " - " + _vm._s(_vm._f("satime")(race.raceDateTime)) + "\n          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "markets-container"
    }, [_c('ResultMarket', {
      attrs: {
        "race": race
      }
    })], 1)])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-container"
  }, [_c('Ticker'), _vm._v(" "), _c('div', {
    staticClass: "brand-item title"
  }, [(!_vm.uploadedImageName) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.brandName) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.uploadedImageName) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.uploadedImageName,
      "alt": ""
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "venue-title-bar",
    style: (_vm.pageTitleBar)
  }, [_c('div', {
    staticClass: "venue-title"
  }, [_vm._v("\n      MULTIPLE EVENTS\n    ")]), _vm._v(" "), (_vm.uploadedImageName) ? _c('div', {
    staticClass: "venue-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.uploadedImagePath,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "the-time"
  }, [_vm._v("\n      " + _vm._s(_vm.theTime) + "\n    ")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "block-one",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('MultiScreenSection', {
    attrs: {
      "quadrant": 1
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "block-two",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('MultiScreenSection', {
    attrs: {
      "quadrant": 2
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "block-three",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('MultiScreenSection', {
    attrs: {
      "quadrant": 3
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "block-four",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('MultiScreenSection', {
    attrs: {
      "quadrant": 4
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "venue-title-bar",
    style: (_vm.pageTitleBar)
  }, [_c('div', {
    staticClass: "country-flag"
  }, [_c('img', {
    attrs: {
      "src": _vm.countryFlag,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "venue-title"
  }, [_vm._v("\n      " + _vm._s(_vm.venueDisplayName) + " - " + _vm._s(_vm.venueDate) + "\n    ")]), _vm._v(" "), (_vm.uploadedImageName) ? _c('div', {
    staticClass: "venue-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.uploadedImagePath,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "the-time"
  }, [_vm._v("\n      " + _vm._s(_vm.theTime) + "\n    ")])]), _vm._v(" "), _c('Ticker'), _vm._v(" "), _c('div', {
    staticClass: "flex-race-container"
  }, _vm._l((_vm.screenData[0].races), function(race) {
    return _c('div', {
      key: race.index,
      class: {
        'venue-two-races': _vm.screenData[0].races.length === 2,
          'venue-more-than-two-races': _vm.screenData[0].races.length > 2,
      }
    }, [_c('div', {
      staticClass: "race-title-bar",
      style: (_vm.raceTitleBar)
    }, [_c('div', {
      staticClass: "race-name"
    }, [_vm._v("\n          " + _vm._s(_vm._f("race")(race.fn)) + " - " + _vm._s(_vm._f("satime")(race.raceDateTime)) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "race-titles"
    }, [_c('div', {
      staticClass: "place-title"
    }, [_vm._v("\n            PLACE\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "prev-title"
    }, [_vm._v("\n            PREV\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "price-title"
    }, [_vm._v("\n            PRICE\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "race-places-paid"
    }, [_vm._v("\n            " + _vm._s(race.placesPaid) + " PLACES PAID (" + _vm._s(race.placePercentage) + "%)\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "markets-container"
    }, [_vm._l((race.markets), function(market) {
      return [(market.marketId) ? [(market.include) ? _c('Market', {
        key: market.id,
        attrs: {
          "places-paid": race.placesPaid,
          "place-percentage": race.placePercentage,
          "venue-id": _vm.screenData[0].venueId,
          "race-id": race.raceId,
          "market-id": market.marketId,
          "venue-index": 1
        }
      }) : _vm._e()] : _vm._e()]
    }), _vm._v(" "), _c('Market', {
      attrs: {
        "scroll-markets": race.scrollMarkets,
        "places-paid": race.placesPaid,
        "place-percentage": race.placePercentage,
        "venue-id": _vm.screenData[0].venueId,
        "race-id": race.raceId,
        "venue-index": 1
      }
    })], 2)])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.quadVenue && _vm.quadVenue.race) ? _c('div', [_c('div', {
    staticClass: "race-title-bar",
    style: (_vm.raceTitleBar)
  }, [_c('div', {
    staticClass: "race-venue-flag"
  }, [_c('img', {
    attrs: {
      "src": _vm.flagImage(_vm.quadVenue.countryName),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "race-venue-name"
  }, [_c('div', {
    staticClass: "venue-name",
    class: _vm.venueFlash
  }, [_vm._v("\n          " + _vm._s(_vm.venueDisplayName(_vm.quadVenue.ve)) + "\n          "), (_vm.hasNextVenue) ? _c('span', {
    staticClass: "showing-next"
  }, [_vm._v("Showing Next in " + _vm._s(_vm.nextVenueIn) + "s.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "race-name",
    class: _vm.raceFlash
  }, [_vm._v("\n          " + _vm._s(_vm._f("race")(_vm.quadVenue.race.fn)) + " - " + _vm._s(_vm._f("satime")(_vm.quadVenue.race.raceDateTime)) + "\n          "), (_vm.hasNextRace) ? _c('span', {
    staticClass: "showing-next"
  }, [_vm._v("Showing Next in " + _vm._s(_vm.nextRaceIn) + "s.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "race-titles"
  }, [_c('div', {
    staticClass: "place-title"
  }, [_vm._v("\n          PLACE\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "prev-title"
  }, [_vm._v("\n          PREV\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "price-title"
  }, [_vm._v("\n          PRICE\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "race-places-paid"
  }, [_vm._v("\n          " + _vm._s(_vm.quadVenue.race.placesPaid) + " PLACES PAID\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "markets-container"
  }, [_vm._l((_vm.quadVenue.race.markets), function(market) {
    return [(market.include) ? _c('Market', {
      key: market.id,
      attrs: {
        "places-paid": _vm.quadVenue.race.placesPaid,
        "place-percentage": _vm.quadVenue.race.placePercentage,
        "venue-id": _vm.quadVenue.venueId,
        "race-id": _vm.quadVenue.race.raceId,
        "market-id": market.marketId,
        "venue-index": _vm.venueIndex,
        "is-multi": true,
        "quadrant": _vm.quadrant
      }
    }) : _vm._e()]
  }), _vm._v(" "), _c('Market', {
    attrs: {
      "scroll-markets": _vm.quadVenue.race.scrollMarkets,
      "places-paid": _vm.quadVenue.race.placesPaid,
      "place-percentage": _vm.quadVenue.race.placePercentage,
      "venue-id": _vm.quadVenue.venueId,
      "race-id": _vm.quadVenue.race.raceId,
      "venue-index": _vm.venueIndex,
      "is-multi": true,
      "quadrant": _vm.quadrant
    }
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.quadVenue) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n    No Venue or Race to Display\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.marketDetails)
  }, [(_vm.market) ? _c('table', {
    staticClass: "market"
  }, [_c('tr', {
    staticClass: "market-row"
  }, [(_vm.silkImageUrl) ? _c('td', {
    staticClass: "silk"
  }, [_c('img', {
    attrs: {
      "src": _vm.silkImageUrl,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v("\n        " + _vm._s(_vm.market.num) + "\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name",
    class: {
      scratched: _vm.market.scratched
    }
  }, [_vm._v("\n          " + _vm._s(_vm.market.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "market-data-jockey"
  }, [_vm._v(_vm._s(_vm.market.jockey))]), _vm._v(" "), (!_vm.market.scratched && _vm.market.jockey && _vm.market.trainer) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "market-data-trainer"
  }, [_vm._v(_vm._s(_vm.market.trainer))])])]), _vm._v(" "), _c('td', {
    staticClass: "name-spacer"
  }), _vm._v(" "), _c('td', {
    staticClass: "price",
    style: (_vm.currentPrice)
  }, [(_vm.market.price) ? _c('span', [_vm._v(_vm._s(_vm.displayPrice))]) : _vm._e(), _vm._v(" "), (!_vm.market.price && !_vm.market.scratched) ? _c('span', [_vm._v("SP")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "prev",
    style: (_vm.previousPrice)
  }, [(_vm.market.previousPrice) ? _c('span', [_vm._v(_vm._s(_vm.previousDisplayPrice))]) : _vm._e(), _vm._v(" "), (!_vm.market.previousPrice && !_vm.market.scratched) ? _c('span', [_vm._v("SP")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('td', {
    staticClass: "place",
    style: (_vm.placePrice)
  }, [_vm._v("\n        " + _vm._s(_vm.placeDisplayPrice) + "  \n      ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.marketDetails)
  }, [(_vm.market) ? _c('table', {
    staticClass: "market"
  }, [_c('tr', {
    staticClass: "market-row"
  }, [(_vm.silkImageUrl) ? _c('td', {
    staticClass: "silk"
  }, [_c('img', {
    attrs: {
      "src": _vm.silkImageUrl,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v("\n        " + _vm._s(_vm.market.num) + "\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name",
    class: {
      scratched: _vm.market.scratched
    }
  }, [_vm._v("\n          " + _vm._s(_vm.market.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('span', {
    staticClass: "market-data-jockey"
  }, [_vm._v(_vm._s(_vm.market.jockey))]), _vm._v(" "), (!_vm.market.scratched && _vm.market.jockey && _vm.market.trainer) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "market-data-trainer"
  }, [_vm._v(_vm._s(_vm.market.trainer))])])]), _vm._v(" "), _c('td', {
    staticClass: "name-spacer"
  }), _vm._v(" "), _c('td', {
    staticClass: "price",
    style: (_vm.currentPrice)
  }, [(_vm.market.price) ? _c('span', {
    class: {
      'odds-on-price': _vm.market.oddsOn
    }
  }, [_vm._v(_vm._s(_vm.displayPrice))]) : _vm._e(), _vm._v(" "), (!_vm.market.price && !_vm.market.scratched) ? _c('span', [_vm._v("SP")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "prev",
    style: (_vm.previousPrice)
  }, [(_vm.market.previousPrice) ? _c('span', [_vm._v(_vm._s(_vm.previousDisplayPrice))]) : _vm._e(), _vm._v(" "), (!_vm.market.previousPrice && !_vm.market.scratched) ? _c('span', [_vm._v("SP")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "place",
    style: (_vm.placePrice)
  }, [_vm._v("\n        " + _vm._s(_vm.placeDisplayPrice) + "\n      ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: []}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "venue-title-bar",
    style: (_vm.pageTitleBar)
  }, [_c('div', {
    staticClass: "venue-title"
  }, [_vm._v("\n      " + _vm._s(_vm.screenConfig ? _vm.screenConfig.screenName : '') + "\n    ")]), _vm._v(" "), (_vm.uploadedImageName) ? _c('div', {
    staticClass: "venue-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.uploadedImagePath,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "the-time"
  }, [_vm._v("\n      " + _vm._s(_vm.screenTime) + "\n    ")])]), _vm._v(" "), _c('Ticker'), _vm._v(" "), _c('div', {
    staticClass: "flex-race-container"
  }, _vm._l((_vm.venues), function(venue, index) {
    return _c('div', {
      key: index,
      staticClass: "flex-race-item",
      class: {
        noedge: venue.index % 3 === 0
      }
    }, [_c('div', {
      staticClass: "race-title-bar",
      style: (_vm.raceTitleBar)
    }, [_c('div', {
      staticClass: "race-venue-flag"
    }, [_c('img', {
      attrs: {
        "src": _vm.flagImage(venue.countryName),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "race-venue-name"
    }, [_c('div', {
      staticClass: "venue-name"
    }, [_vm._v("\n            " + _vm._s(_vm.venueDisplayName(venue.ve)) + "\n          ")]), _vm._v(" "), (venue.races.length) ? _c('div', {
      staticClass: "race-name"
    }, [_vm._v("\n            " + _vm._s(_vm._f("race")(venue.races[0].fn)) + " - " + _vm._s(_vm.raceTime(venue.races[0].raceDateTime)) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "race-titles"
    }, [_c('div', {
      staticClass: "place-title"
    }, [_vm._v("\n            PLACE\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "prev-title"
    }, [_vm._v("\n            PREV\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "price-title"
    }, [_vm._v("\n            PRICE\n          ")]), _vm._v(" "), (venue.races.length) ? _c('div', {
      staticClass: "race-places-paid"
    }, [_vm._v("\n            " + _vm._s(venue.races[0].placesPaid) + " PLACES PAID\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (venue.races.length) ? _c('div', {
      staticClass: "markets-container"
    }, [_vm._l((venue.races[0].markets), function(market) {
      return [(market.marketId) ? [(market.include) ? _c('Market', {
        key: market.id,
        attrs: {
          "places-paid": venue.races[0].placesPaid,
          "place-percentage": venue.races[0].placePercentage,
          "venue-id": venue.venueId,
          "race-id": venue.races[0].raceId,
          "market-id": market.marketId,
          "venue-index": index + 1
        }
      }) : _vm._e()] : _vm._e()]
    }), _vm._v(" "), _c('Market', {
      attrs: {
        "scroll-markets": venue.races[0].scrollMarkets,
        "places-paid": venue.races[0].placesPaid,
        "place-percentage": venue.races[0].placePercentage,
        "venue-id": venue.venueId,
        "race-id": venue.races[0].raceId,
        "venue-index": index + 1
      }
    })], 2) : _vm._e()])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "venue-title-bar",
    style: (_vm.pageTitleBar)
  }, [_c('div', {
    staticClass: "country-flag"
  }, [_c('img', {
    attrs: {
      "src": _vm.countryFlag,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "venue-title"
  }, [_vm._v("\n      " + _vm._s(_vm.venueDisplayName) + " - " + _vm._s(_vm.venueDate) + "\n    ")]), _vm._v(" "), (_vm.uploadedImageName) ? _c('div', {
    staticClass: "venue-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.uploadedImagePath,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "the-time"
  }, [_vm._v("\n      " + _vm._s(_vm.theTime) + "\n    ")])]), _vm._v(" "), _c('Ticker'), _vm._v(" "), _c('div', {
    staticClass: "flex-race-container"
  }, _vm._l((_vm.screenData[0].races), function(race) {
    return _c('div', {
      key: race.index,
      staticClass: "flex-race-item",
      class: {
        noedge: race.index % 3 === 0
      }
    }, [_c('div', {
      staticClass: "race-title-bar",
      style: (_vm.raceTitleBar)
    }, [_c('div', {
      staticClass: "race-name"
    }, [_vm._v("\n          " + _vm._s(_vm._f("race")(race.fn)) + " - " + _vm._s(_vm._f("satime")(race.raceDateTime)) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "race-titles"
    }, [_c('div', {
      staticClass: "place-title"
    }, [_vm._v("\n            PLACE\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "prev-title"
    }, [_vm._v("\n            PREV\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "price-title"
    }, [_vm._v("\n            PRICE\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "race-places-paid"
    }, [_vm._v("\n            " + _vm._s(race.placesPaid) + " PLACES PAID (" + _vm._s(race.placePercentage) + "%)\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "markets-container"
    }, [_vm._l((race.markets), function(market) {
      return [(market.marketId) ? [(market.include) ? _c('MarketSmall', {
        key: market.id,
        attrs: {
          "places-paid": race.placesPaid,
          "place-percentage": race.placePercentage,
          "venue-id": _vm.screenData[0].venueId,
          "race-id": race.raceId,
          "market-id": market.marketId,
          "venue-index": 1
        }
      }) : _vm._e()] : _vm._e()]
    }), _vm._v(" "), _c('MarketSmall', {
      attrs: {
        "scroll-markets": race.scrollMarkets,
        "places-paid": race.placesPaid,
        "place-percentage": race.placePercentage,
        "venue-id": _vm.screenData[0].venueId,
        "race-id": race.raceId,
        "venue-index": 1
      }
    })], 2)])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "marquee-tips",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.races) ? _c('div', [_vm._v("\n        loading races...\n      ")]) : _vm._e(), _vm._v(" "), (_vm.races) ? _c('div', _vm._l((_vm.races), function(race) {
    return _c('div', {
      key: race.ve,
      staticClass: "race"
    }, [_vm._v("\n          " + _vm._s(race.ve) + "\n        ")])
  }), 0) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.marketDetails)
  }, [(_vm.race.fileType === 'resultprovisional') ? _c('table', {
    staticClass: "market"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.race.fileType === 'resultfinal') ? _c('table', {
    staticClass: "market"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.race.fileType === 'resultfinal' || _vm.race.fileType === 'resultprovisional') ? _c('table', {
    staticClass: "market"
  }, [(_vm.race.h1) ? _c('tr', {
    staticClass: "market-row"
  }, [_c('td', {
    staticClass: "number"
  }, [_vm._v("\n        1st\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n          " + _vm._s(parseInt(_vm.race.h1.num, 10)) + " " + _vm._s(_vm.race.h1.name) + "\n        ")])]), _vm._v(" "), _c('td', {
    staticClass: "name-spacer"
  }), _vm._v(" "), _c('td', {
    staticClass: "price"
  }, [_vm._v("\n        " + _vm._s(_vm.race.h1.startingPrice) + "\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "place"
  }, [(_vm.race.placeData && _vm.race.placeData.placesPaid >= 1) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.placeDisplayPrice(_vm.race.h1, _vm.race.placeData)) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.race.h2) ? _c('tr', {
    staticClass: "market-row"
  }, [_c('td', {
    staticClass: "number"
  }, [_vm._v("\n        2nd\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(parseInt(_vm.race.h2.num, 10)))]), _vm._v(" " + _vm._s(_vm.race.h2.name) + "\n        ")])]), _vm._v(" "), _c('td', {
    staticClass: "name-spacer"
  }), _vm._v(" "), _c('td', {
    staticClass: "price"
  }, [_vm._v("\n        " + _vm._s(_vm.race.h2.startingPrice) + "\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "place"
  }, [(_vm.race.placeData && _vm.race.placeData.placesPaid >= 2) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.placeDisplayPrice(_vm.race.h2, _vm.race.placeData)) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.race.h3) ? _c('tr', {
    staticClass: "market-row"
  }, [_c('td', {
    staticClass: "number"
  }, [_vm._v("\n        3rd\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n          " + _vm._s(parseInt(_vm.race.h3.num, 10)) + " " + _vm._s(_vm.race.h3.name) + "\n        ")])]), _vm._v(" "), _c('td', {
    staticClass: "name-spacer"
  }), _vm._v(" "), _c('td', {
    staticClass: "price"
  }, [_vm._v("\n        " + _vm._s(_vm.race.h3.startingPrice) + "\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "place"
  }, [(_vm.race.placeData && _vm.race.placeData.placesPaid >= 3) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.placeDisplayPrice(_vm.race.h3, _vm.race.placeData)) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.race.h4) ? _c('tr', {
    staticClass: "market-row"
  }, [_c('td', {
    staticClass: "number"
  }, [_vm._v("\n        4th\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n          " + _vm._s(parseInt(_vm.race.h4.num, 10)) + " " + _vm._s(_vm.race.h4.name) + "\n        ")])]), _vm._v(" "), _c('td', {
    staticClass: "name-spacer"
  }), _vm._v(" "), _c('td', {
    staticClass: "price"
  }, [_vm._v("\n        " + _vm._s(_vm.race.h4.startingPrice) + "\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "place"
  }, [(_vm.race.placeData && _vm.race.placeData.placesPaid >= 4) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.placeDisplayPrice(_vm.race.h4, _vm.race.placeData)) + "\n        ")]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.race.fileType === 'racecard') ? _c('table', {
    staticClass: "market"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "market-row-provisional"
  }, [_c('td', [_c('div', [_vm._v("\n          PROVISIONAL RESULT\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "market-row-final"
  }, [_c('td', [_c('div', [_vm._v("\n          FINAL RESULT\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "market-row"
  }, [_c('td', {
    staticClass: "runner"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n          Awaiting Results\n        ")])])])
}]}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infobar",
    style: (_vm.infoBar)
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("\n    " + _vm._s(_vm.infoBarMessage) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-default reset-button",
    on: {
      "click": function($event) {
        return _vm.resetScreenWindow()
      }
    }
  }, [_vm._v("\n      Reset screen window\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-default reset-button",
    on: {
      "click": function($event) {
        return _vm.resetScreenPc()
      }
    }
  }, [_vm._v("\n      Reset screen PC\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n    " + _vm._s(_vm.bookieName) + " "), (_vm.bookieName) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.screenName) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marquee"
  }, [(_vm.tickerInfo.enabled) ? _c('MarqueeTips', {
    class: _vm.tickerSizeClass,
    style: (_vm.tickerStyle),
    attrs: {
      "content": _vm.tickerInfo.message,
      "speed": 10
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container",
    attrs: {
      "id": "app"
    }
  }, [_c('Startup'), _vm._v(" "), _c('InfoBar')], 1)
},staticRenderFns: []}

/***/ })
],[190]);


// WEBPACK FOOTER //
// static/js/app.bf96f2bb5e54a012f506.js